module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Demi.adf3d4c1.woff";